import { atom } from "jotai";
import type { ShippingPolicyResponse } from "@models/shipping";

// Q11 defaults — a safe fallback so shipping renders before (or if) the
// GET /shipping/policy hydration fails; overwritten on successful fetch.
export const shippingPolicyAtom = atom<ShippingPolicyResponse>({
    freeThreshold: 10000,
    belowThresholdFee: 7.99,
});

export const isFetchingShippingPolicyAtom = atom<boolean>(false);
